/* eslint-disable */
import React, { useEffect, useState } from "react";
import "./PortalLoader.css";
import { prefetchService } from "../../../../utils/commonFunctions/prefetchService";

interface PortalLoaderProps {
	onLoadingComplete: () => void;
	duration?: number; // in milliseconds
}

export const PortalLoader: React.FC<PortalLoaderProps> = ({
	onLoadingComplete,
	duration = 10000 // 10 seconds default
}) => {
	const [progress, setProgress] = useState(0);
	const [fadeOut, setFadeOut] = useState(false);
	const [currentStep, setCurrentStep] = useState(0);

	const steps = [
		"Authenticating",
		"Fetching Enrollments",
		"Loading Profile",
		"Fetching Benefits",
		"Preparing Dashboard"
	];

	// UI ANIMATION LOGIC
	useEffect(() => {
		const progressInterval = setInterval(() => {
			setProgress((prev) => {
				if (prev >= 100) {
					clearInterval(progressInterval);
					return 100;
				}
				return prev + 100 / (duration / 100);
			});
		}, 100);

		const stepInterval = setInterval(() => {
			setCurrentStep((prev) => (prev < steps.length - 1 ? prev + 1 : prev));
		}, duration / steps.length);

		const fadeTimeout = setTimeout(() => setFadeOut(true), duration - 500);
		const completeTimeout = setTimeout(() => onLoadingComplete(), duration);

		return () => {
			clearInterval(progressInterval);
			clearInterval(stepInterval);
			clearTimeout(fadeTimeout);
			clearTimeout(completeTimeout);
		};
	}, [duration, onLoadingComplete]);

	return (
		<div className={`portal-loader ${fadeOut ? "fade-out" : ""}`}>
			<div className="bg-grid"></div>
			<div className="bg-glow glow-1"></div>
			<div className="bg-glow glow-2"></div>

			<div className="loader-content">
				<div className="loader-header">
					<div className="status-badge">System Initializing</div>
					<h1 className="loader-title">Member Portal</h1>
					<p className="loader-subtitle">Secure CRM Environment</p>

					<div className="system-info">
						<span className="system-info-item">End-to-End Encryption</span>
						<span className="system-info-item">HIPAA Compliant</span>
						<span className="system-info-item">Secure Health Records</span>
					</div>
				</div>

				<div className="progress-wrapper">
					<div className="progress-header">
						<span className="progress-label">Initializing Services</span>
						<span className="progress-percentage">{Math.round(progress)}%</span>
					</div>
					<div className="progress-container">
						<div className="progress-bar" style={{ width: `${progress}%` }}></div>
					</div>
				</div>

				<div className="loading-steps" style={{ "--progress": `${progress}%` } as React.CSSProperties}>
					{steps.map((step, index) => (
						<div
							key={index}
							className={`step ${index <= currentStep ? "active" : ""} ${
								index < currentStep ? "completed" : ""
							}`}
						>
							<div className="step-indicator">
								{index < currentStep ? (
									<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
										<polyline points="20 6 9 17 4 12"></polyline>
									</svg>
								) : (
									<div className="step-dot"></div>
								)}
							</div>
							<div className="step-content">
								<span className="step-label">{step}</span>
								{index === currentStep && <span className="step-meta">Processing...</span>}
							</div>
						</div>
					))}
				</div>
			</div>

			<div className="security-footer">
				<div className="security-badge">
					<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
						<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
					</svg>
					256-bit TLS Encryption Active
				</div>
			</div>
		</div>
	);
};
